module.exports = __webpack_public_path__ + "img/Mayotte.927335d0.svg";